import React from 'react'

export default function ManagementGuide({
  biofixDate,
  managementGuide,
  eggDiapauseDate,
  eggDevDate,
  instar1Date,
  instar2Date,
  instar3Date,
  instar4Date,
  completeAdultEmergence,
}) {
  let lifeStage = ''
  let management = ''

  if (eggDiapauseDate || biofixDate) {
    lifeStage = managementGuide.eggDiapause.lifeStage
    management = managementGuide.eggDiapause.management
  } else {
    lifeStage = 'Eggs are in diapause'
    management =
      'Content for egg diapause management will be populated by NYSIPM in December 2021.'
  }

  if (eggDevDate) {
    lifeStage = managementGuide.eggDev.lifeStage
    management = managementGuide.eggDev.management
  }

  if (instar1Date) {
    lifeStage = managementGuide.instar1.lifeStage
    management = managementGuide.instar1.management
  }

  if (instar2Date) {
    lifeStage = managementGuide.instar2.lifeStage
    management = managementGuide.instar2.management
  }

  if (instar3Date) {
    lifeStage = managementGuide.instar3.lifeStage
    management = managementGuide.instar3.management
  }

  if (instar4Date) {
    lifeStage = managementGuide.instar4.lifeStage
    management = managementGuide.instar4.management
  }

  if (completeAdultEmergence) {
    lifeStage = 'Adults have emerged'
    management = 'Emergence reached 100%'
  }

  return (
    <>
      <h2 className="mb-8 text-xl font-semibold text-gray-600 md:text-2xl">
        Management Guide
      </h2>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-secondary-800">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-xs leading-4 tracking-wider text-left text-white uppercase border-b border-gray-200"
                    >
                      Disease Cycle
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-xs leading-4 tracking-wider text-left text-white uppercase border-b border-gray-200"
                    >
                      Disease Management
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-white">
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {lifeStage}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {management}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
